/**
 * Message keys for Attorney/Law Firm case onboarding flow.
 * Uses "Case" terminology instead of "Claim" for attorney-specific flows.
 */
export enum ECaseMessagesKeys {
  // Step title
  TITLE = "ONBOARDING.CASE.TITLE",
  TABNAME = "ONBOARDING.CASE.TABNAME",

  // Form block titles
  CASE_DETAILS_BLOCK_TITLE = "ONBOARDING.CASE.CASE_DETAILS_BLOCK_TITLE",
  CASE_DETAILS_SUBTITLE = "ONBOARDING.CASE.CASE_DETAILS_SUBTITLE",
  ADDITIONAL_INFO_BLOCK_TITLE = "ONBOARDING.CASE.ADDITIONAL_INFO_BLOCK_TITLE",

  // Field labels
  ACCIDENT_DATE_TITLE = "ONBOARDING.CASE.ACCIDENT_DATE_TITLE",
  CASE_NUMBER_TITLE = "ONBOARDING.CASE.CASE_NUMBER_TITLE",
  LICENSE_PLATE_TITLE = "ONBOARDING.CASE.LICENSE_PLATE_TITLE",
  VIN_TITLE = "ONBOARDING.CASE.VIN_TITLE",
  DRIVER_FIRST_NAME_TITLE = "ONBOARDING.CASE.DRIVER_FIRST_NAME_TITLE",
  DRIVER_LAST_NAME_TITLE = "ONBOARDING.CASE.DRIVER_LAST_NAME_TITLE",

  // Placeholders
  LICENSE_PLATE_PLACEHOLDER = "ONBOARDING.CASE.LICENSE_PLATE_PLACEHOLDER",
  VIN_PLACEHOLDER = "ONBOARDING.CASE.VIN_PLACEHOLDER",
  DRIVER_FIRST_NAME_PLACEHOLDER = "ONBOARDING.CASE.DRIVER_FIRST_NAME_PLACEHOLDER",
  DRIVER_LAST_NAME_PLACEHOLDER = "ONBOARDING.CASE.DRIVER_LAST_NAME_PLACEHOLDER",

  // Consent text for attorney flow
  CONSENT_TEXT = "ONBOARDING.CASE.CONSENT_TEXT",
  CONSENT_ACKNOWLEDGEMENT_TEXT = "ONBOARDING.CASE.CONSENT_ACKNOWLEDGEMENT_TEXT",

  // Summary block
  SUMMARY_CASE_INFO_TITLE = "ONBOARDING.CASE.SUMMARY_CASE_INFO_TITLE",
  SUMMARY_DATE_OF_ACCIDENT = "ONBOARDING.CASE.SUMMARY_DATE_OF_ACCIDENT",
  SUMMARY_DEFENDANT_NAME = "ONBOARDING.CASE.SUMMARY_DEFENDANT_NAME",
  SUMMARY_TABNAME = "ONBOARDING.CASE.SUMMARY_TABNAME",
  SUMMARY_TITLE = "ONBOARDING.CASE.SUMMARY_TITLE",

  // Recipient label
  RECIPIENT_LABEL = "ONBOARDING.CASE.RECIPIENT_LABEL",

  // Default reason text for recipients
  DEFAULT_REASON = "ONBOARDING.CASE.DEFAULT_REASON",

  // Congratulations page
  CONGRATS_SUBTITLE = "ONBOARDING.CASE.CONGRATS_SUBTITLE",
}
